module.exports = __webpack_public_path__ + "static/media/chevron-square-right.d3b5c844.svg";